<template>
  <HcScrollContainer
    :largura-max="larguraMax"
    :largura-min="larguraMin"
    :unidade-largura="unidadeLargura"
    :altura-max="alturaMax"
    :altura-min="alturaMin"
    :unidade-altura="unidadeAltura"
    v-stream:scroll.native="scroll$"
  >
    <slot />
    <div
      ref="scrollLoader"
      v-show="carregando"
      class="scroll-loader col text-center p-t-10 p-b-10"
      :style="styleLoader"
    >
      <slot name="mensagem-loading">{{ carregandoText }}</slot>
    </div>
  </HcScrollContainer>
</template>

<script>
import { debounceTime, pluck } from "rxjs/operators";
import HcScrollContainer from "./ScrollContainer";

const ALTURA_LOADER = 41;

export default {
  name: "HcScrollPaginado",
  components: {
    HcScrollContainer
  },
  props: {
    alturaMin: {
      type: [Number, String],
      default: 100
    },
    alturaMax: {
      type: [Number, String]
    },
    unidadeAltura: {
      type: String,
      default: "%"
    },
    larguraMin: {
      type: [Number, String],
      default: 100
    },
    larguraMax: {
      type: [Number, String]
    },
    unidadeLargura: {
      type: String,
      default: "%"
    },
    carregandoText: {
      type: String,
      default: "Carregando"
    },
    temPagina: {
      type: Boolean,
      default: true
    }
  },
  data,
  computed: {
    styleLoader
  },
  methods: {
    onScroll
  },
  domStreams: ["scroll$"],
  subscriptions
};

function data() {
  return {
    carregando: false,
    loaderTop: ALTURA_LOADER
  };
}

function styleLoader() {
  return {
    top: `${this.loaderTop}px`
  };
}

function onScroll(scroll) {
  if (this.temPagina) {
    if (
      scroll.target.scrollHeight ===
      scroll.target.clientHeight + scroll.target.scrollTop
    ) {
      this.carregando = true;
      this.loaderTop = scroll.target.scrollHeight - ALTURA_LOADER;

      const carregandoPromise = new Promise(resolve =>
        this.$emit("proxima-pagina", resolve)
      );

      carregandoPromise.then(() => (this.carregando = false));
    }
  }
}

function subscriptions() {
  this.scroll$
    .asObservable()
    .pipe(
      debounceTime(300),
      pluck("event")
    )
    .subscribe(event => this.onScroll(event));
}
</script>
